import { Link, useLocation } from "react-router-dom";

export default function UnifiedSidebar({ user, isOpen, setIsOpen, isMobile }) {
  const location = useLocation();

  // ✅ Define menu items for each role
  const getMenuItems = () => {
   if (user?.role === "admin") {
  return [
    { id: "dashboard", path: "/admin", label: "Dashboard", icon: "📊" },
    { id: "asset-manager", path: "/admin/asset-manager", label: "Asset Manager", icon: "💻" },
    { id: "disposed-assets", path: "/admin/disposed-assets", label: "Disposed Assets", icon: "🗂️" },
    { id: "user-administration", path: "/admin/user-administration", label: "User Administration", icon: "👤" },
    { id: "request-approval", path: "/admin/request-approval", label: "Request Approval", icon: "📋" },
    { id: "map-editor", path: "/admin/map-editor", label: "Map Editor", icon: "🗺️" },
    { id: "qr-tools", path: "/admin/qr-tools", label: "Asset and QR Generator", icon: "🔍" },
    { id: "end-week-report", path: "/admin/end-week-report", label: "End Week Report", icon: "📅" },
  ];
} else if (user?.role === "student") {
  return [
    { id: "dashboard", path: "/dashboard", label: "Dashboard", icon: "📊" },
    { id: "assets", path: "/student/browse", label: "Assets", icon: "💻" },
    { id: "request", path: "/student/item-request", label: "Request", icon: "📝" },
    { id: "return-asset", path: "/student/return-scan", label: "Return Asset", icon: "↩️" },
    { id: "request-list", path: "/student/requests", label: "Request List", icon: "📋" },
  ];
} else if (user?.role === "technician") {
  return [
    { id: "dashboard", path: "/dashboard", label: "Dashboard", icon: "📊" },
    { id: "tasks", path: "/technician/tasks", label: "Tasks", icon: "📋" },
    { id: "reports", path: "/technician/reports", label: "Reports", icon: "📄" },
    { id: "scan-qr", path: "/technician/scan", label: "Scan QR", icon: "📱" },
  ];
}

    return [];
  };

  const menuItems = getMenuItems();

  return (
    <div
      className={`transition-all duration-300 bg-white dark:bg-gray-800 shadow-lg h-screen p-4 fixed top-0 z-50 ${
        isOpen ? "w-64" : "w-16"
      } ${
        isMobile ? 'left-0' : isOpen ? 'left-0' : '-left-48'
      }`}
    >
      {/* ✅ Profile Section */}
      {isOpen && (
        <div className="flex flex-col items-center mb-6">
          <img
            src={user?.profilePicture || "/adminnew.jpg"}
            alt="Profile"
            className="w-16 h-16 rounded-full mb-2 object-cover border-2 border-gray-300 dark:border-gray-600"
          />

          <h2 className="text-lg font-semibold text-gray-900 dark:text-white text-center">
            {user?.name}
          </h2>

          <span className="text-sm text-gray-600 dark:text-gray-400 capitalize">
            {user?.role}
          </span>
        </div>
      )}

      {/* ✅ Navigation */}
      <nav className="space-y-4">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={() => isMobile && setIsOpen(false)}
            className={`flex items-center px-4 py-3 rounded-lg transition-all duration-200 transform hover:scale-105 hover:shadow-lg ${
              location.pathname === item.path
                ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-md border-l-4 border-blue-700"
                : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:shadow-md"
            }`}
          >
            <span className="mr-3 text-lg">{item.icon}</span>
            {isOpen && <span className="text-sm font-medium">{item.label}</span>}
          </Link>
        ))}
      </nav>
    </div>
  );
}
